var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { CommonThemeColors } from "../theme";
var LegendItem = function (_a) {
    var color = _a.color, label = _a.label;
    return (_jsxs(Stack, __assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", direction: "row" }, { children: [_jsx(Box, { sx: {
                    width: 20,
                    height: 20,
                    backgroundColor: color,
                    border: "1px solid ".concat(CommonThemeColors.black),
                    marginRight: 1,
                } }), _jsx(Typography, __assign({ variant: "h6" }, { children: label }))] })));
};
export default LegendItem;
